import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import LinearGradient from 'react-native-linear-gradient'
import { Dimensions, FlatList, Image, Platform } from "react-native";
import BajajLogo from "../../../../assets/Icons/BajajLogo"
import DSPLogo from "../../../../assets/Icons/DSPLogo"
import TataLogo from "@app/assets/svg/TataLogo";
import { CollateralType, CreditType } from "@app/configs/constants";
import fetchUserDetails from "@app/helper/fetchUserInfo";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { updateLMSUserDashboard } from "@app/store/slices/commonSlice";
import promiseFetchUserInfo from "@app/helper/promiseFetchUserInfo";
import { useState } from "react";

const ViewAllLoans = ({switchAccountDetails, setViewAllLoansDetails}: {switchAccountDetails: any, setViewAllLoansDetails: any}) => {
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const accountId = userDetails?.linkedApplications[0]?.accountId;
    const name = userDetails?.user?.fullName?.split(' ')[0] ?? ''
    const creditDetailsList = switchAccountDetails?.creditDetailsList;
    const creditInfo = useAppSelector((state) => state.auth.creditDetails);
    const dispatch = useAppDispatch();

    const getLenderLogo = (id: string) => {
        const logoObj ={
        tata: <TataLogo/>,
        bajaj: <BajajLogo/>,
        dsp: <DSPLogo color1={themeColorSet['icon-primary']}/>,
        }
        return logoObj[id?.toLowerCase() as keyof typeof logoObj];
    }    
    
    const handlePress = (item: any) => {
        const payload = {
            accountId: accountId,
            updatedCreditId: item?.creditId
        }

        const handleSwitchCredit = async () => {
            try{
                const res = await axios.post(endpoints.switchCredit,payload);
                setViewAllLoansDetails(false)
                await promiseFetchUserInfo();
                dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
            }catch(err){
                console.log('err',err);
            }
        }

        handleSwitchCredit();
    }

    const renderCandlestickChart = (creditType: string) => {
        const creditTypeImageUrl = creditType === CreditType.CREDIT_LINE_LAS ? 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/shares_icon.png' : 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/mf_icon.png';
        return (
            <ThemedView pt={creditType === CreditType.CREDIT_LINE_LAS ? undefined : "2xl"}>
                <Image source={{ uri: creditTypeImageUrl }} style={{ width: 64, height: 64 }} />
            </ThemedView>
            
        )
    }

      
    const DiagonalGradientStrips = ({ color }: { color: string }) => {
        return (
          <>
            {[0, 1, 2].map(index => (
              <LinearGradient
                key={index}
                colors={[
                  `${color}36`,
                  `${color}00`, 
                ]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  position: 'absolute',
                  width: 36,              
                  height: 270,
                  top: -100,              
                  right: -56 + index * 50, 
                  transform: [{ rotate: '-135deg' }],
                  borderRadius: 4,        
                }}
              />
            ))}
          </>
        );
    }

    const [hoverIndex, setHoverIndex] = useState(-1);
    const sheetHeight = Math.min(Dimensions.get('window').height * 0.85, 720);
    const containerStyle = Platform.OS === 'web' ? { flex: 1 } : { height: sheetHeight };
    
    return (
        <ThemedView backgroundColor="bg-fill-primary" p="lg" pt="2xl" style={containerStyle}>
            <ThemedText variant="h3s" color="text-primary">Hi {name},</ThemedText>
            <ThemedText variant="b2r" color="text-primary">Choose loan account to continue</ThemedText>
            <FlatList
                data={creditDetailsList}
                keyExtractor={(item) => item?.creditId}
                renderItem={({item,index}) => (
                    <ThemedPressable style={{
                        backgroundColor: hoverIndex === index ? item?.creditType === CreditType.CREDIT_LINE_LAS ? '#EDECFC' : '#E8FFEE' : 'transparent',
                        borderRadius: 12,
                        borderColor: hoverIndex === index ? item?.creditType === CreditType.CREDIT_LINE_LAS ? '#5635C0' : '#109648' : '#E0E1E6',
                        borderWidth: 1,
                      }}
                     borderRadius="lg" mt="2xl" overflow="hidden" 
                    onHoverIn={() => setHoverIndex(index)} onHoverOut={() => setHoverIndex(-1)} onPress={() => handlePress(item)}>
                        <ThemedView position="relative" overflow="hidden">
                            <DiagonalGradientStrips
                                color={
                                item?.creditType === CreditType.CREDIT_LINE_LAS
                                    ? '#7C6EF6'
                                    : '#56BC73'
                                }
                            />
                            <ThemedView
                                px="lg"
                                flexDirection="row"
                                justifyContent="space-between"
                            >
                                <ThemedView pt="lg" pb='sm'>
                                    <ThemedText variant="b4r" color="text-secondary">
                                        Available limit
                                    </ThemedText>
                                    <ThemedView flexDirection="row" alignItems="center" mt="2xs">
                                        <ThemedText variant="l1" color="text-primary">₹</ThemedText>
                                        <ThemedText variant="h1s" color="text-primary">
                                        {formatIndianCurrency(Math.floor(item?.availableCreditAmount))}
                                        </ThemedText>
                                    </ThemedView>
                                </ThemedView>
                                <ThemedView style={{ marginRight: 16 }}>
                                {renderCandlestickChart(item?.creditType)}
                                </ThemedView>
                            </ThemedView>
                        </ThemedView>
                        <ThemedView borderColor='border-primary' borderTopWidth={1}/> 
                        <ThemedView mt='sm' px="lg" pb='lg' flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ThemedView>
                                <ThemedText variant="b4r" color="text-secondary" mb="xs">Lender</ThemedText>
                                {getLenderLogo(item?.lenderId)}
                            </ThemedView>
                            <ThemedView>
                                <ThemedText variant="b4r" color="text-secondary" mb="xs">Loans against</ThemedText>
                                <ThemedText textAlign="right" variant="b4s" color="text-primary">{item?.creditType   === CreditType.CREDIT_LINE_LAS ? 'Shares' : 'Mutual Funds'}</ThemedText>
                            </ThemedView>
                        </ThemedView>
                    </ThemedPressable>
                   
                )}
            />
        </ThemedView>
       
    )
}

  

export default ViewAllLoans;